<template>
  <v-container fluid>
    <v-card class="elevation-2 py-3 px-6 rounded-lg">
      <v-row class="pa-0"> 
        <v-col cols="12" md="3" class="d-flex justify-center">
          <v-select
            :items="periods"
            v-model="selectedPeriod"
            label="Period Summary"
            dense
            hide-details
            outlined
        ></v-select>
        </v-col>
        <v-col cols="12" md="3" class="d-flex justify-start justify-md-start pb-0 pt-0 mt-0 mt-md-4">
          <WeekFilters
            v-if="selectedPeriod == 'Week Summary'"
            :weeksEnd="weeksEnd" 
            :weeks="period" 
            @getDates="getWeeks"
            :disabled="loadedWeek"
          />
          <MonthFilters
            v-else
            :end="dateEnd" 
            :start="dateStart" 
            @getDates="getMonths"
            :disabled="loadedMonth"
          />
        </v-col>
        <v-spacer></v-spacer>
        <LastTimeUpdated :selectedDate="'updateGoogleAds'" class=" mt-0 mt-md-4"/>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-0 px-0 mt-4 rounded-lg" v-if="selectedPeriod == 'Week Summary'">
      <v-card-title>
        <div style="position: absolute; top:20px">
            <v-btn @click="openRelatedPage('marketing-adwords')" target="_blank" style="margin-right: 12px">
              <v-icon>mdi-link-variant</v-icon> Google Ads
            </v-btn>
            <v-btn @click="openRelatedPage('marketing-bing')" target="_blank">
              <v-icon>mdi-link-variant</v-icon> Bing Ads
            </v-btn>
        </div>
        <v-row class="pa-0">                
          <v-col cols="12" class="d-flex justify-end justify-md-end pb-0 pt-0 mt-0">
            <vue-excel-xlsx
              :data="dataWeekForExcel"
              :columns="columnsData"
              :filename="`Total Marketing Report - ${selectedPeriod}`"
              :sheetname="`${period} ${period > 1 ? 'weeks' : 'week'} to ${dateEnd}`"
            >
              <v-btn
                height="39"           
                min-width="39px"        
                :disabled="!dataWeeks.data"
                class="ml-auto mr-5 rounded-lg px-0"                           
                color="white"
              >
                <ExportExcel />
              </v-btn> 
            </vue-excel-xlsx>
            <CustomColumns 
              :currentValue="valueWeek"
              :currentCustomHeader="customHeaderWeek"
              :currentHeaders="headersWeek"
              :settingsName="`${settingsName}Week`"
              @getCustomData="getCustomDataWeek"
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-hover v-model="hoverOnTable">
        <v-card-text>
          <div class="d-flex justify-space-between">
            <v-btn
              class="mx-2 scroll-btn btn-left-arrow"
              fab
              small     
              @click="scrollingLeft"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-btn
              class="mx-2 scroll-btn btn-right-arrow"
              fab
              small
              @click="scrollingRight"
            >
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-data-table
            :headers="selectedHeadersWeek"
            fixed-header
            height="536"
            :items="dataWeeks.data"
            item-key="title"
            class="elevation-0 table-main-container"
            :loading="loadedWeek"
            loading-text="Loading... Please wait"
            :page.sync="pagination.page"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, 75, 100, -1]
              }"
            @click:row="rowClick"
          >
            <template  v-for="e in slotsWeekMonth" v-slot:[`item.${e.name}`]="{ item }">
              <div class="d-flex flex-column align-end align-md-center"  :key="e.name">
                <div v-if="e.filter=='formatFloat' && item[`${e.name}`]!=0">{{ item[`${e.name}`] | formatFloat }}</div>
                <div v-if="e.filter=='formatPrice' && item[`${e.name}`]!=0">${{ item[`${e.name}`] | formatPrice }}</div>
                <div v-if="item[`${e.name}`]==0">0</div>
              </div>
            </template>
          </v-data-table>       
        </v-card-text>
      </v-hover>   
    </v-card>
    <v-card class="elevation-2 py-1 px-0 mt-4 rounded-lg" v-else>
       <v-card-title>
         <div style="position: absolute; top:20px">
            <v-btn @click="openRelatedPage('marketing-adwords')" target="_blank" style="margin-right: 12px">
              <v-icon>mdi-link-variant</v-icon> Google Ads
            </v-btn>
            <v-btn @click="openRelatedPage('marketing-bing')" target="_blank">
              <v-icon>mdi-link-variant</v-icon> Bing Ads
            </v-btn>
         </div>
        <v-row class="pa-0">                
          <v-col cols="12" class="d-flex justify-end justify-md-end pb-0 pt-0 mt-0">
            <vue-excel-xlsx
              :data="dataMonthForExcel"
              :columns="columnsData"
              :filename="`Total Marketing Report - ${selectedPeriod}`"
              :sheetname="`${dateStart} ~ ${dateEnd}`"
            >
              <v-btn
                height="39"           
                min-width="39px"        
                :disabled="!dataMonths.data"
                class="ml-auto mr-5 rounded-lg px-0"                           
                color="white"
              >
                <ExportExcel />
              </v-btn> 
            </vue-excel-xlsx>
            <CustomColumns 
              :currentValue="valueMonth"
              :currentCustomHeader="customHeaderMonth"
              :currentHeaders="headersMonth"
              :settingsName="`${settingsName}Month`"
              @getCustomData="getCustomDataMonth"
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-hover v-model="hoverOnTable">
        <v-card-text>
          <div class="d-flex justify-space-between">        
            <v-btn
              class="mx-2 scroll-btn btn-left-arrow"
              fab
              small     
              @click="scrollingLeft"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-btn
              class="mx-2 scroll-btn btn-right-arrow"
              fab
              small
              @click="scrollingRight"
            >
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-data-table
            :headers="selectedHeadersMonth"
            fixed-header
            height="536"
            :items="dataMonths.data"
            :custom-sort="customSort"
            item-key="title"
            class="elevation-0 table-main-container"
            :loading="loadedMonth"
            loading-text="Loading... Please wait"
            :page.sync="pagination.page"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, 75, 100, -1]
              }"
            @click:row="rowClick"
          >
            <template  v-for="e in slotsWeekMonth" v-slot:[`item.${e.name}`]="{ item }">
              <div class="d-flex flex-column align-end align-md-center"  :key="e.name">
                <div v-if="e.filter=='formatFloat' && item[`${e.name}`]!=0">{{ item[`${e.name}`] | formatFloat }}</div>
                <div v-if="e.filter=='formatPrice' && item[`${e.name}`]!=0">${{ item[`${e.name}`] | formatPrice }}</div>
                <div v-if="item[`${e.name}`]==0">0</div>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-hover>  
    </v-card>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import MonthFilters from '@/components/filters/MonthFilters'
import WeekFilters from '@/components/filters/WeekFilters'
import CustomColumns from '@/components/customizing/CustomColumns'
import ExportExcel from '@/components/customizing/ExportExcel'
import LastTimeUpdated from "@/views/LastTimeUpdated";

export default {
  components: {
    WeekFilters,
    MonthFilters,
    CustomColumns,
    ExportExcel,
    LastTimeUpdated
  },
  data() {
    return {
      periods: ['Week Summary', 'Month Summary'],
      selectedPeriod: 'Week Summary',
      headersWeek: [
          {text: 'Week', value: 'title', width: '112px', class: 'black--text'},
          {text: 'Clicks', value: 'clicks', class: 'black--text'},
          {text: 'Clicks Changes,%', value: 'click_changes_pct', class: 'black--text'},
          {text: 'Impressions', value: 'impressions', class: 'black--text'},
          {text: 'Expenses', value: 'cost', class: 'black--text'},
          {text: 'Expenses Changes,%', value: 'cost_changes_pct', class: 'black--text'},
          {text: 'CPC', value: 'cpc', class: 'black--text'},
          {text: 'Total Conversions', value: 'total_conversions', class: 'black--text'},
          {text: 'Conversion Changes,%', value: 'total_conversions_changes_pct', class: 'black--text'},
          {text: 'Expenses Per Conversion', value: 'cost_per_conversions', class: 'black--text'},
          {text: 'Expenses Per Conversion Changes,%', value: 'cost_per_conversions_changes_pct', class: 'black--text'},
          {text: 'Total Orders', value: 'orders', class: 'black--text'},
          {text: 'Total Expenses per Order', value: 'cost_per_order', class: 'black--text'},
          {text: 'Expenses per Order Changes,%', value: 'cost_per_order_changes_pct', class: 'black--text'},
          {text: 'Total Gallons', value: 'gallons', class: 'black--text'},
          {text: 'Price 1 Gallon', value: 'avg_cost_per_gallon', class: 'black--text'},
          {text: 'Price 1 Gallon Changes,%', value: 'gallons_changes_pct', class: 'black--text'},
          {text: 'Price 1 Gallon Avg 12 weeks', value: 'avg_price_one_gallon_12_weeks', class: 'black--text'},
          {text: 'Price 1 Gallon Avg 30 days', value: 'avg_price_one_gallon_30_days', class: 'black--text'},
          {text: 'Price 1 Gallon Avg 7 days', value: 'avg_price_one_gallon_7_days', class: 'black--text'},
          {text: 'Orders per conversions', value: 'order_conversions', class: 'black--text'},
          {text: 'Orders FR', value: 'clear_orders', class: 'black--text'},
          {text: 'Gallons FR', value: 'clear_gallons', class: 'black--text'},
          {text: 'Orders Fire Barrier', value: 'barrier_orders', class: 'black--text'},
          {text: 'Gallons Fire Barrier', value: 'barrier_gallons', class: 'black--text'},
          {text: 'Total Revenue', value: 'total_sales', class: 'black--text'},
          {text: 'Total Revenue Changes,%', value: 'total_sales_changes_pct', class: 'black--text'},
          {text: 'Avg. Revenue', value: 'average_check', class: 'black--text'},
          {text: 'Total Callrail In Calls', value: 'total_calls', class: 'black--text'},
          {text: 'Expenses per CallRail Call', value: 'avg_cost_per_call', class: 'black--text'},
      ],
      valueWeek: [
          {text: 'Week', value: 'title', width: '112px', class: 'black--text'},
          {text: 'Clicks', value: 'clicks', class: 'black--text'},
          {text: 'Clicks Changes,%', value: 'click_changes_pct', class: 'black--text'},
          {text: 'Impressions', value: 'impressions', class: 'black--text'},
          {text: 'Expenses', value: 'cost', class: 'black--text'},
          {text: 'Expenses Changes,%', value: 'cost_changes_pct', class: 'black--text'},
          {text: 'CPC', value: 'cpc', class: 'black--text'},
          {text: 'Total Conversions', value: 'total_conversions', class: 'black--text'},
          {text: 'Conversion Changes,%', value: 'total_conversions_changes_pct', class: 'black--text'},
          {text: 'Expenses Per Conversion', value: 'cost_per_conversions', class: 'black--text'},
          {text: 'Expenses Per Conversion Changes,%', value: 'cost_per_conversions_changes_pct', class: 'black--text'},
          {text: 'Total Orders', value: 'orders', class: 'black--text'},
          {text: 'Total Expenses per Order', value: 'cost_per_order', class: 'black--text'},
          {text: 'Expenses per Order Changes,%', value: 'cost_per_order_changes_pct', class: 'black--text'},
          {text: 'Total Gallons', value: 'gallons', class: 'black--text'},
          {text: 'Price 1 Gallon', value: 'avg_cost_per_gallon', class: 'black--text'},
          {text: 'Price 1 Gallon Changes,%', value: 'gallons_changes_pct', class: 'black--text'},
          {text: 'Total Revenue', value: 'total_sales', class: 'black--text'},
          {text: 'Total Revenue Changes,%', value: 'total_sales_changes_pct', class: 'black--text'},
          {text: 'Avg. Revenue', value: 'average_check', class: 'black--text'},
          {text: 'Total Callrail In Calls', value: 'total_calls', class: 'black--text'},
          {text: 'Expenses per CallRail Call', value: 'avg_cost_per_call', class: 'black--text'},
      ],
      headersMonth: [
          {text: 'Month', value: 'title', width: '136px', class: 'black--text'},
          {text: 'Clicks', value: 'clicks', class: 'black--text'},
          {text: 'Clicks Changes,%', value: 'click_changes_pct', class: 'black--text'},
          {text: 'Impressions', value: 'impressions', class: 'black--text'},
          {text: 'Expenses', value: 'cost', class: 'black--text'},
          {text: 'Expenses Changes,%', value: 'cost_changes_pct', class: 'black--text'},
          {text: 'CPC', value: 'cpc', class: 'black--text'},
          {text: 'Total Conversions', value: 'total_conversions', class: 'black--text'},
          {text: 'Conversion Changes,%', value: 'total_conversions_changes_pct', class: 'black--text'},
          {text: 'Expenses Per Conversion', value: 'cost_per_conversions', class: 'black--text'},
          {text: 'Expenses Per Conversion Changes,%', value: 'cost_per_conversions_changes_pct', class: 'black--text'},
          {text: 'Total Orders', value: 'orders', class: 'black--text'},
          {text: 'Total Expenses per Order', value: 'cost_per_order', class: 'black--text'},
          {text: 'Expenses per Order Changes,%', value: 'cost_per_order_changes_pct', class: 'black--text'},
          {text: 'Total Gallons', value: 'gallons', class: 'black--text'},
          {text: 'Price 1 Gallon', value: 'avg_cost_per_gallon', class: 'black--text'},
          {text: 'Price 1 Gallon Changes,%', value: 'gallons_changes_pct', class: 'black--text'},
          {text: 'Price 1 Gallon Avg 12 weeks', value: 'avg_price_one_gallon_12_weeks', class: 'black--text'},
          {text: 'Price 1 Gallon Avg 30 days', value: 'avg_price_one_gallon_30_days', class: 'black--text'},
          {text: 'Orders per conversions', value: 'order_conversions', class: 'black--text'},
          {text: 'Orders FR', value: 'clear_orders', class: 'black--text'},
          {text: 'Gallons FR', value: 'clear_gallons', class: 'black--text'},
          {text: 'Orders Fire Barrier', value: 'barrier_orders', class: 'black--text'},
          {text: 'Gallons Fire Barrier', value: 'barrier_gallons', class: 'black--text'},
          {text: 'Total Revenue', value: 'total_sales', class: 'black--text'},
          {text: 'Total Revenue Changes,%', value: 'total_sales_changes_pct', class: 'black--text'},
          {text: 'Avg. Revenue', value: 'average_check', class: 'black--text'},
          {text: 'Total Callrail In Calls', value: 'total_calls', class: 'black--text'},
          {text: 'Expenses per CallRail Call', value: 'avg_cost_per_call', class: 'black--text'},
      ],
      valueMonth: [
          {text: 'Month', value: 'title', width: '136px', class: 'black--text'},
          {text: 'Clicks', value: 'clicks', class: 'black--text'},
          {text: 'Clicks Changes,%', value: 'click_changes_pct', class: 'black--text'},
          {text: 'Impressions', value: 'impressions', class: 'black--text'},
          {text: 'Expenses', value: 'cost', class: 'black--text'},
          {text: 'Expenses Changes,%', value: 'cost_changes_pct', class: 'black--text'},
          {text: 'CPC', value: 'cpc', class: 'black--text'},
          {text: 'Total Conversions', value: 'total_conversions', class: 'black--text'},
          {text: 'Conversion Changes,%', value: 'total_conversions_changes_pct', class: 'black--text'},
          {text: 'Expenses Per Conversion', value: 'cost_per_conversions', class: 'black--text'},
          {text: 'Expenses Per Conversion Changes,%', value: 'cost_per_conversions_changes_pct', class: 'black--text'},
          {text: 'Total Orders', value: 'orders', class: 'black--text'},
          {text: 'Total Expenses per Order', value: 'cost_per_order', class: 'black--text'},
          {text: 'Expenses per Order Changes,%', value: 'cost_per_order_changes_pct', class: 'black--text'},
          {text: 'Total Gallons', value: 'gallons', class: 'black--text'},
          {text: 'Price 1 Gallon', value: 'avg_cost_per_gallon', class: 'black--text'},
          {text: 'Price 1 Gallon Changes,%', value: 'gallons_changes_pct', class: 'black--text'},
          {text: 'Total Revenue', value: 'total_sales', class: 'black--text'},
          {text: 'Total Revenue Changes,%', value: 'total_sales_changes_pct', class: 'black--text'},
          {text: 'Avg. Revenue', value: 'average_check', class: 'black--text'},
          {text: 'Total Callrail In Calls', value: 'total_calls', class: 'black--text'},
          {text: 'Expenses per CallRail Call', value: 'avg_cost_per_call', class: 'black--text'},
      ],
      customHeaderWeek: [
                        'title', 'clicks', 'click_changes_pct', 'impressions', 'cost',
                        'cost_changes_pct', 'cpc', 'total_conversions', 'total_conversions_changes_pct',
                        'cost_per_conversions', 'cost_per_conversions_changes_pct','orders',
                        'cost_per_order', 'cost_per_order_changes_pct', 'gallons', 'avg_cost_per_gallon',
                        'gallons_changes_pct', 'total_sales', 'total_sales_changes_pct', 'average_check',
                        'total_calls', 'avg_cost_per_call'
                        ],
      customHeaderMonth: [
                        'title', 'clicks', 'click_changes_pct', 'impressions', 'cost',
                        'cost_changes_pct', 'cpc', 'total_conversions', 'total_conversions_changes_pct',
                        'cost_per_conversions', 'cost_per_conversions_changes_pct','orders',
                        'cost_per_order', 'cost_per_order_changes_pct', 'gallons', 'avg_cost_per_gallon',
                        'gallons_changes_pct', 'total_sales', 'total_sales_changes_pct', 'average_check',
                        'total_calls', 'avg_cost_per_call'
                        ],
      selectedHeadersWeek: [],
      selectedHeadersMonth: [],
      dataWeeks: [],
      dataMonths: [],
      dataWeeksByCampaigns: [],
      dataMonthsByCampaigns: [],
      userName: null,
      dateStart: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth() - 7,
                    new Date(
                        new Date().getFullYear(), 
                        new Date().getMonth()).getDate() + 1
                        ).toISOString().substr(0, 10),
      dateEnd: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth() + 1,
                    ).toISOString().substr(0, 10),
      weeksEnd: new Date().toISOString().substr(0, 10),
      period: '20',
      loadedWeek: false,
      loadedMonth: false,
      options: {
        responsive: true,
        maintainAspectRatio: false
      },
      allCampaigns: [],
      allAdGroups: [],
      campaigns: [],
      settingsName: 'aggMarketingReport',
      columnsData: [],
      scrollLeft: 0,
      scrollWidth: 0,
      clientWidth: 0,
      hoverOnTable: false,
      pagination: {
        page: 1
      },
      slotsWeekMonth: [
          {name: 'clicks', filter: 'formatFloat'},
          {name: 'impressions', filter: 'formatFloat'},
          {name: 'cost', filter: 'formatPrice'},
          {name: 'cost_per_conversions', filter: 'formatPrice'},
          {name: 'cost_per_order', filter: 'formatPrice'},
          {name: 'gallons', filter: 'formatFloat'},
          {name: 'avg_cost_per_gallon', filter: 'formatPrice'},
          {name: 'total_sales', filter: 'formatPrice'},
          {name: 'avg_cost_per_call', filter: 'formatPrice'},
          {name: 'total_calls', filter: 'formatFloat'},
          {name: 'average_check', filter: 'formatPrice'},
          {name: 'total_conversions', filter: 'formatFloat'},
          {name: 'avg_price_one_gallon_12_weeks', filter: 'formatPrice'},
          {name: 'avg_price_one_gallon_30_days', filter: 'formatPrice'},
          {name: 'avg_price_one_gallon_7_days', filter: 'formatPrice'},
          {name: 'barrier_orders', filter: 'formatFloat'},
          {name: 'barrier_gallons', filter: 'formatFloat'},
        ],
    }
  },
  watch: {
    valueWeek(val) {
      this.selectedHeadersWeek = val
      this.getHeaderForExcel()
    },
    valueMonth(val) {
      this.selectedHeadersMonth = val
      this.getHeaderForExcel()
    },
    hoverOnTable(){
      this.showScrollingArrows()
    },
    selectedPeriod(){
      this.pagination.page = 1
    }
  },
  created() {
    this.selectedHeadersWeek = this.valueWeek
    this.selectedHeadersMonth = this.valueMonth
    this.getHeaderForExcel()
    window.addEventListener("resize", this.showScrollingArrows)
  },
  destroyed() {
    window.removeEventListener("resize", this.showScrollingArrows)
  },
  mounted() {
    axios
        .get('/username')
        .then(response => (this.userName = response.data));
    axios
      .get('/campaigns')
        .then(response => {
          this.allCampaigns = response.data
          for (let i = 0; i < this.allCampaigns.length; i++) {
            this.allAdGroups.push({name: this.allCampaigns[i].campaignName, id: this.allCampaigns[i].campaignId})
          }

          this.campaigns = this._.chain(this.allCampaigns)
              .groupBy("campaignId")
              .map((value, key) => ({id: key, name: value[0].campaignName}))
              .value()
        });

    this.getDateRange()
    this.loadReports()
    this.showScrollingArrows()
  },
  computed: {
    dataWeekForExcel(){
      if (!this.dataWeeks.data) return []
      let data = JSON.parse(JSON.stringify(this.dataWeeks.data))
      return data
    },
    dataMonthForExcel(){
      if (!this.dataMonths.data) return []
      let data = JSON.parse(JSON.stringify(this.dataMonths.data))
      return data
    },
  },
  methods: {
    openRelatedPage(pageName){
      localStorage.setItem('marketingReport', JSON.stringify({
        report: 'marketingReport',
        order_ids: [],
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
        weeksEnd: this.weeksEnd,
        period: this.period,
        selectedPeriod: this.selectedPeriod
      }))

      let routeData = this.$router.resolve({name: pageName})
      window.open(routeData.href, '_blank')
    },
    scrollingRight(){
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft + 50

      const btnRight = document.querySelector('.btn-right-arrow')
      const btnLeft = document.querySelector('.btn-left-arrow')
      btnRight.style.visibility = (this.hoverOnTable && (el.scrollLeft + el.clientWidth != el.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    scrollingLeft(){
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft - 50

      const btnLeft = document.querySelector('.btn-left-arrow')
      const btnRight = document.querySelector('.btn-right-arrow')
      btnLeft.style.visibility = (this.hoverOnTable && (el.scrollLeft != 0)) ? 'visible' : 'hidden'
      btnRight.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    showScrollingArrows(){
      const el = document.querySelector('.v-data-table__wrapper')
      this.scrollLeft = el.scrollLeft
      this.scrollWidth = el.scrollWidth
      this.clientWidth = el.clientWidth

      const btnRight = document.querySelector('.btn-right-arrow')
      const btnLeft = document.querySelector('.btn-left-arrow')
      btnRight.style.visibility = (this.hoverOnTable && (this.scrollLeft + this.clientWidth !== this.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = (this.hoverOnTable && (this.scrollLeft != 0)) ? 'visible' : 'hidden'
    },
    getDateRange(){
      if (sessionStorage.getItem('weeksEnd')) {
        this.weeksEnd = sessionStorage.getItem('weeksEnd')
      }
      if (sessionStorage.getItem('period')) {
        this.period = sessionStorage.getItem('period')
      }
      if (sessionStorage.getItem('monthStart')) {
        this.dateStart = sessionStorage.getItem('monthStart')
      }
      if (sessionStorage.getItem('monthEnd')) {
        this.dateEnd = sessionStorage.getItem('monthEnd')
      }
    },
    getHeaderForExcel(){
      let selectedHeaders = (this.selectedPeriod === 'Week Summary') ? this.selectedHeadersWeek : this.selectedHeadersMonth

      this.columnsData = selectedHeaders.map(e => {
        const obj = {}
        if (e.value !== "actions") {
          obj.label = e.text
          obj.field = e.value
        }
        if (e.value === "cost" ||
            e.value === "cost_per_conversions" ||
            e.value === "cost_per_order" ||
            e.value === "avg_cost_per_gallon" ||
            e.value === "avg_price_one_gallon_7_days" ||
            e.value === "avg_price_one_gallon_12_weeks" ||
            e.value === "avg_price_one_gallon_30_days" ||
            e.value === "total_sales" ||
            e.value === "average_check" ||
            e.value === "avg_cost_per_call"
            ) {
          obj.label = `${e.text},$`
          obj.field = e.value
        }
        return obj
      })
    },
    customSort: function(items, index, isDesc) {
      items.sort((a, b) => {
          if (index[0]=='title') {
            if (!isDesc[0]) {
                return new Date(b[index]) - new Date(a[index]);
            } else {
                return new Date(a[index]) - new Date(b[index]);
            }
          }
          else {
            if(typeof a[index] !== 'undefined'){
              if (!isDesc[0]) {
                 return a[index] - b[index];
              }
              else {
                  return b[index] - a[index]
              }
            }
          }
      });
      return items;
    },
    loadReports() {
      this.dataWeeks = []
      this.dataMonths = []
      this.loadedWeek = true
      this.loadedMonth = true
      axios
        .get('/reports/marketing-total/week-summary/' + this.weeksEnd + '/' + this.period)
        .then(response => {
          response.data.data.map(elem => {

            for (let item in elem) {
              if (typeof elem[item]  === 'string' ) {
                continue;
              }
              elem[item] = Math.floor(elem[item] * 100) / 100
            }
          })

          this.dataWeeks = response.data
          this.loadedWeek = false
        })
    axios
        .get('/reports/marketing-total/month-summary/' + this.dateStart + '/' + this.dateEnd)
        .then(response => {
          response.data.data.map(elem => {

            for (let item in elem) {
              if (typeof elem[item]  === 'string' ) {
                continue;
              }
              elem[item] = Math.floor(elem[item] * 100) / 100
            }
          })

          this.dataMonths = response.data
          this.loadedMonth = false
        })

        let userName = localStorage.getItem('username')
        let clientId = (localStorage.getItem('ClientId')) ? localStorage.getItem('ClientId') : 1
        let settings = this.settingsName
          if (localStorage.getItem(`${userName}.${clientId}.${settings}Week`)) {

            try {
              let valueWeekCash = JSON.parse(localStorage.getItem(`${userName}.${clientId}.${settings}Week`))
              this.valueWeek = valueWeekCash.filter(e => this.headersWeek.find(item => item.value === e.value))
              
              const parsed = JSON.stringify(this.valueWeek)
              localStorage.setItem(`${userName}.${clientId}.${settings}Week`, parsed)


              this.customHeaderWeek = this.valueWeek.map(e => e.value)
            } catch(e) {
              console.log("")
            }
          }

          if (localStorage.getItem(`${userName}.${clientId}.${settings}Month`)) {

            try {
              let valueMonthCash = JSON.parse(localStorage.getItem(`${userName}.${clientId}.${settings}Month`))
              this.valueMonth = valueMonthCash.filter(e => this.headersMonth.find(item => item.value === e.value))
              
              const parsed = JSON.stringify(this.valueMonth)
              localStorage.setItem(`${userName}.${clientId}.${settings}Month`, parsed)

              this.customHeaderMonth = this.valueMonth.map(e => e.value)
            } catch(e) {
              console.log("")
            }
          }
    },
    getWeeks(dates){
        this.period = dates.period
        this.weeksEnd = dates.weeksEnd
        this.pagination.page = 1
        this.applyFiltersWeek()
    },
    getMonths(dates){
        this.dateStart = dates.dateStart
        this.dateEnd = dates.dateEnd
        this.pagination.page = 1
        this.applyFiltersMonth()
    },
    applyFiltersMonth() {
      this.loadedMonth = true
      axios
        .get('/reports/marketing-total/month-summary/' + this.dateStart + '/' + this.dateEnd)
        .then(response => {
          response.data.data.map(elem => {
            
            for (let item in elem) {
              if (typeof elem[item]  === 'string' ) {
                continue;
              }
              elem[item] = Math.floor(elem[item] * 100) / 100
            }
          });
          this.dataMonths = response.data
          this.loadedMonth = false
        });
    },
    applyFiltersWeek() {
      this.loadedWeek = true
      axios
          .get('/reports/marketing-total/week-summary/' + this.weeksEnd + '/' + this.period)
          .then(response => {
            response.data.data.map(elem => {
            
            for (let item in elem) {
              if (typeof elem[item]  === 'string' ) {
                continue;
              }
              elem[item] = Math.floor(elem[item] * 100) / 100
            }
          });
            this.dataWeeks = response.data
            this.loadedWeek = false
          });
    },
    getCustomDataWeek({customHeader, value, selectedHeaders}){
      this.customHeaderWeek = customHeader
      this.valueWeek = value
      this.selectedHeadersWeek = selectedHeaders
    },
    getCustomDataMonth({customHeader, value, selectedHeaders}){
      this.customHeaderMonth = customHeader
      this.valueMonth = value
      this.selectedHeadersMonth = selectedHeaders
    },
    rowClick: function (item, row) {     
      let selectState = (row.isSelected) ? false : true
      row.select(selectState)
    }
  }
}
</script>

<style>
  .test table > tbody > tr > td:nth-child(1), 
  .theme--light.v-data-table .v-data-table__wrapper > thead > tr > th:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0;
    top: 0;
    background: white;
  }
  .btn-right-arrow {
    right: 0px;
    top: 60px;
  }
  .btn-left-arrow {
    left: 0px;
    top: 60px;
  }
</style>